import { Flex, Typography, TitleFixed } from 'UI';
import React, { FC } from 'react';
import { FONT_WEIGHT, TextColor, TEXT_COLOR } from 'styles/constants';

interface Props {
	title?: string;
	subtitle?: string;
	children?: React.ReactNode;
	titleSize?: number;
	titleColor?: TextColor | string;
	titleWeight?: number;
	subtitleSize?: number;
	subtitleColor?: TextColor | string;
	subtitleWeight?: number;
	image?: React.ReactNode;
	marginTop?: string;
	configPilates?: boolean;
	obDiet?: boolean;
}

export const QuestionWrapper: FC<Props> = props => {
	const {
		title,
		titleSize = 22,
		titleColor = TEXT_COLOR.TEXT1,
		titleWeight = FONT_WEIGHT.BOLD,
		subtitle,
		subtitleColor = TEXT_COLOR.TEXT1,
		subtitleSize = 16,
		subtitleWeight = FONT_WEIGHT.REGULAR,
		image,
		children,
		marginTop,
		configPilates,
		obDiet,
	} = props;

	return (
		<Flex direction='column' gap={15} height='fit-content' marginTop={marginTop}>
			{title &&
				(obDiet ? (
					<TitleFixed>{title}</TitleFixed>
				) : (
					<Typography
						size={titleSize}
						color={titleColor}
						weight={titleWeight}
						textAlign={configPilates ? 'center' : 'left'}
					>
						{title}
					</Typography>
				))}
			{subtitle && (
				<Typography
					size={subtitleSize}
					color={subtitleColor}
					weight={subtitleWeight}
					textAlign={configPilates ? 'center' : 'left'}
				>
					{subtitle}
				</Typography>
			)}
			{image && (
				<Flex justify='center' align='center'>
					{image}
				</Flex>
			)}
			{children}
		</Flex>
	);
};
